import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { take } from 'rxjs/operators';

import {
    CustomHttpParamEncoder,
    ShAbstractHttpService,
    ShApiCachingHelper,
    UserFunction
} from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class FunctionsService {
    private readonly functionsEndpoint: string = 'v2/functions';
    private functions$: Observable<UserFunction[]>;

    constructor(protected http: ShAbstractHttpService, private apiCachingHelper: ShApiCachingHelper) {}

    private initFunctions(): Observable<UserFunction[]> {
        const cachedFunctions$: Observable<UserFunction[]> = this.apiCachingHelper.cachedApiCall(this.getFunctions());

        this.apiCachingHelper.cachedApiCall(cachedFunctions$).subscribe(functions => (this.functions$ = of(functions)));

        return cachedFunctions$.pipe(take(1));
    }

    // #region GET

    public getFunctions(onlyAssignable = false): Observable<UserFunction[]> {
        const params: HttpParams = new HttpParams({ encoder: new CustomHttpParamEncoder() }).set(
            'onlyAssignable',
            onlyAssignable
        );
        return this.http.get(this.functionsEndpoint, params);
    }

    public getAllFunctions(): Observable<UserFunction[]> {
        return this.functions$ ?? this.initFunctions();
    }

    // #endregion
}
